export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M3.729 4.007a.5.5 0 00.5.5h6.807l-7.632 7.632a.5.5 0 10.707.707l7.632-7.632v6.807a.5.5 0 101 0V4.007a.5.5 0 00-.5-.5H4.229a.5.5 0 00-.5.5z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};